export enum ShadowStyle {
  MEDIUM = 'shadow-md',
  SMALL = 'shadow-sm',
  EXTRA_SMALL = 'shadow-xs',
  NONE = 'shadow-none',
}
